import { Api } from '../api'

const getProjects = (facilityId) => {
    return Api.get(`/projects/${facilityId ? facilityId : ''}`);
};

const getItemCountForProject = (projectId) => {
    return Api.get(`/customers/${projectId}/item-count`);
};

export default {
    getProjects,
    getItemCountForProject
};